<form #editStatusConsultaForm="ngForm">
    <app-custom-modal #modal [title]="'Atualizar Status da Consulta'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Atualizar →'"
        [saveDisabled]="editStatusConsultaForm.invalid && saving">
        <div class="container">
            <div>
                <label for="statusConsulta" class="form-label required">Status da consulta</label>
                <select name="statusConsulta" class="form-control" id="statusConsulta" required
                    [(ngModel)]="consulta.statusConsulta">
                    <option *ngFor="let status of statusConsulta.status" [value]="status.type">{{status.name}}</option>
                </select>
            </div>
        </div>
    </app-custom-modal>
</form>